import {
  Card,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { PRIMARY_SOURCE } from "../../../config/constant";

function TermsAndConditionReferralForm() {
  const { enquiryDetails } = useSelector((state) => state?.customerForm);
  const primarySource = enquiryDetails?.data?.primarySource;
  const projectName = enquiryDetails?.data?.projectName;
  return (
    <Card
      sx={{
        padding: "26px 0px",
        boxShadow: "none",
        borderRadius: "8px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "600",
          color: "#1A407D",
          mb: "16px",
        }}
      >
        Terms and Conditions
      </Typography>
      {primarySource === PRIMARY_SOURCE?.PurvaPrivilege ? (
        <div className="referralProgramTerms">


          <ol className="ListNumber">
            <li>
              1. {projectName?.includes("Ecopolitan") ? "Provident Premier" : "Purva Privilege"} is a program offered by {projectName?.includes("Ecopolitan") ? "Provident Housing Limited" : "Puravankara Limited"}.
              exclusively for home owners in {projectName?.includes("Ecopolitan") ? "Provident Housing Limited" : "Puravankara Limited"}. projects or
              projects developed by its subsidiary companies.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              2. The applicant is required to submit this Referral Registration
              Form, when they wish to refer any interested person to buy a
              property in any {projectName?.includes("Ecopolitan") ? "Provident " : "Puravankara"} Projects.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              3. Existing owners who approach the Company through Brokers, Real
              Estate Agents and Channel Partners of {projectName?.includes("Ecopolitan") ? "Provident " : "Puravankara"} are not eligible
              to participate in this scheme.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              4. Any referral registered by an existing owner will be valid for
              only 90 days and shall lapse unless extended by the company, or
              upon receipt of an extension from by the referrer/ applicant. Any
              sale closed, thereafter is not entitled to any referral benefit.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              5. Once a referral is registered with complete details of the
              interested person, the sales team shall do the needful in
              converting the sale and update the status to the referrer. The
              referrer is eligible for referral benefit only after Agreement for
              Sale and Construction Agreement are executed by such customer
              along with payment of 15% of the sale value. 15% payment for
              ongoing and ready to move in projects.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              6. The referral benefit shall be restricted to 2% (1% to referrer
              and 1% to referee) of the Basic Cost of the apartment excluding
              taxes and other charges, in the form of Privilege Points. The
              Privilege points shall be credited within 45 days, post 15% of
              payment towards the unit. For self-purchase, up-to 2 % of the
              Basic Cost of the unit excluding taxes and other charges, will be
              paid in the form of Privilege points. The referral points so
              credited to the referee's {projectName?.includes("Ecopolitan") ? "Provident Premier" : "Purva Privilege"} account can be redeemed
              through {projectName?.includes("Ecopolitan") ? "Provident Premier" : "Purva Privilege"} website {projectName?.includes("Ecopolitan") ? "(www.providentpremier.com)" : "(www.purvaprivilege.com)"}
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              7. The disputes arising out of this policy between the applicant
              and the sales team shall be referred to arbitration by the Head of
              Customer Experience & Loyalty Sales whose decision shall be final
              and binding on both parties.
            </li>
          </ol>
        </div>
      ) : null}

      {primarySource === PRIMARY_SOURCE?.ProvidentPremiere ? (
        <div className="referralProgramTerms">
    

          <ol className="ListNumber">
            <li>
              1. Provident Premier is a program offered by Provident Housing
              Limited exclusively to existing and ex-property owners of
              {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"} (“Referrer”), during the currency of
              this programme.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              2. Referrers are required to submit a Referral Registration Form,
              as soon as their referred family or friend buy
              Flat/condos/villa/plots property in any {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"}.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              3. Referrers who approach the Company through Brokers, Real Estate
              Agents and Channel Partners of {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"} /
              Puravankara are not eligible to participate in this scheme.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              4. Any referral registered by the Referrer on the portal
              (Providentpremier.com) will be valid for only 90 days for that
              referral and shall lapse unless extended by the company, or upon
              receipt of an extension form by the referrer / applicant. In case
              the sale is not concluded within 90 days or such extended time,
              the Referrer will not be entitled to any Referral Rewards.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              5. As soon as a referral is registered on the portal
              (providentpremir.com) with complete details of person interested
              in purchasing an apartment, the Cognizant Office shall do the
              needful in converting the sale and shall update the status to the
              Referrer. The Referrer is eligible for referral rewards in the
              form of points only after Agreement for Sale and Construction
              Agreement are executed by such customer along with 15% of the sale
              value.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              6. The Referral Rewards shall be restricted to 2% of the Basic
              Cost of the apartment (taxes and other charges excluded) which is
              equally distributed between Referrer & Referee. For repeat
              Purchase up-to 2% of Basic Cost of the apartment/ plot as Reward
              Points which can be utilised in the manner provided above.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              7. Rewards are provided in the form of Points – 1 Point is
              equivalent to1 rupees – Subject to change without notice.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              8. Any disputes that may arise in relation to this policy the
              matter shall be referred to arbitration by the Director, Sales and
              Marketing of {projectName === "Ecopolitan" ? "Provident White Oaks LLP" : "Provident Housing Limited"}, whose decision shall be
              final and binding on the Referrer.
            </li>
          </ol>
          <ol className="ListNumber">
            <li>
              9. The Reward payable shall stand adjusted against any outstanding
              amount payable under any head to Provident / Puravankara. Balance
              amount if any payable post such adjustment will be adjusted
              against future demands that will be raised by Puravankara/
              Provident.
            </li>
          </ol>
        </div>
      ) : null}
 

    </Card>
  );
}

export default TermsAndConditionReferralForm;
